import { useEffect, useRef } from "react";
import { REVIEWS } from "@/data/products";
import { useLang } from "@/context/LanguageContext";

export const ReviewsCarousel = () => {
    const { lang, t } = useLang();
    const carouselRef = useRef(null);
    const pausedRef = useRef(false);
    const resumeRef = useRef(null);

    useEffect(() => {
        const el = carouselRef.current;
        if (!el) return;
        const timer = setInterval(() => {
            if (pausedRef.current) return;
            const card = el.querySelector("[data-review-card]");
            const step = card ? card.offsetWidth + 20 : 300;
            if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) {
                el.scrollTo({ left: 0, behavior: "smooth" });
            } else {
                el.scrollBy({ left: step, behavior: "smooth" });
            }
        }, 3500);
        return () => clearInterval(timer);
    }, []);

    const pauseNow = () => {
        pausedRef.current = true;
        if (resumeRef.current) clearTimeout(resumeRef.current);
    };
    const resumeSoon = () => {
        pausedRef.current = true;
        if (resumeRef.current) clearTimeout(resumeRef.current);
        resumeRef.current = setTimeout(() => {
            pausedRef.current = false;
        }, 4000);
    };

    return (
        <div data-testid="reviews-photo-section">
            <h3 className="font-serif text-2xl sm:text-3xl text-stone-900 text-center">
                {t("reviews.title")}
            </h3>
            <div
                ref={carouselRef}
                data-testid="reviews-carousel"
                onMouseEnter={pauseNow}
                onMouseLeave={resumeSoon}
                onTouchStart={pauseNow}
                onTouchEnd={resumeSoon}
                className="no-scrollbar mt-6 flex gap-4 sm:gap-5 overflow-x-auto snap-x snap-mandatory pb-2"
            >
                {REVIEWS.map((r, i) => (
                    <div
                        key={i}
                        data-review-card
                        data-testid={`review-card-${i + 1}`}
                        className={`snap-center shrink-0 w-[225px] sm:w-[270px] bg-white border border-stone-200 rounded-xl shadow-[0_16px_32px_-20px_rgba(0,0,0,0.4)] p-3 ${
                            i % 2 ? "rotate-1" : "-rotate-1"
                        }`}
                    >
                        <img
                            src={r.image}
                            alt={`Cliente ${r.name}`}
                            loading="lazy"
                            className="w-full aspect-[3/4] object-cover rounded-lg"
                        />
                        <p className="mt-3 text-amber-400 tracking-[0.2em] text-sm">★★★★★</p>
                        <p className="mt-1.5 font-serif italic text-[15px] text-stone-800 leading-snug">
                            “{r[lang]}”
                        </p>
                        <p className="mt-2.5 text-xs font-semibold text-stone-500">{r.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};